import { combineReducers } from 'redux';

import viewSettings from '../../src/modules/WallPreview/viewSettingsReducer';

const reducer = combineReducers({
    viewSettings
});

export default reducer;
